import React, { Component, Fragment } from 'react';
export default class ErrorHandler extends Component {
  render(){
    return <div>Somthing went wrong!</div>
  }
}



// WEBPACK FOOTER //
// ./src/ErrorHandler.js